
export class TabItemModel {
  private _hidden: boolean = false;
  title: string;

  mediator: TabGroupModel;
  hasSubtabs?: boolean;
  tabs?: { [tabKey: string]: TabItemModel };

  get hidden() {
    return this._hidden;
  }

  set hidden(value: boolean) {
    this._hidden = value;
    this.mediator.tabHidden(this);
  }

  get active() {
    return this.mediator.activeTab === this;
  }

  activate() {
    this.mediator.activeTab = this;
  }

  constructor(
    mediator: TabGroupModel,
    title: string,
    hasSubtabs?: boolean,
    tabs?: { [tabKey: string]: TabItemModel }) {
    this.mediator = mediator;
    this.title = title;
    this.hasSubtabs = hasSubtabs;
    this.tabs = tabs;
  }

}

export class TabGroupModel {
  private _tabs: TabItemModel[];
  activeTab: TabItemModel;

  get tabs() {
    return this._tabs?.filter(x => !x.hidden) ?? [];
  }

  set tabs(value: TabItemModel[]) {
    this._tabs = value;
    this.setActiveTab();
  }

  tabHidden(tab: TabItemModel) {
    if (tab.hidden && this.activeTab == tab) {
      // current active tab was hidden
      this.setActiveTab();
    }
  }

  get allTabsHidden(): boolean {
    return this._tabs?.every(tab => tab.hidden) ?? true;
  }

  private setActiveTab() {
    const visibleTab = this._tabs?.find(x => (!x.hidden && (!x.hasSubtabs || Object.values(x?.tabs ?? []).some(y => !y.hidden))));
    if (visibleTab) {
      this.activeTab = visibleTab;
    }
  }
}

